import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import PublicSideNav from 'containers/SideNav/public';
import PublicSiteRoute from 'containers/SiteRoute/public';
import LoginPage from 'pages/Account/Login';
import PasswordReset from 'pages/Account/PasswordReset';

import "./App.scss";

const SideNavPages = () => {
    return (
        <div className="main-container">
            <PublicSideNav></PublicSideNav>
            <div className="main-content">
                <PublicSiteRoute></PublicSiteRoute>
            </div>
        </div>
    )
}

function App() {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />}></Route>
            <Route path="/password-reset" element={<PasswordReset />}></Route>
            <Route path="/*" element={
                <SideNavPages />
            } />
        </Routes>
    );
}

export default App;